module.exports = __webpack_public_path__ + "static/media/GATO.30424f00.png";